import {isEmpty} from "lodash"

import {
  SET_CURRENT_USER,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  SIGNUP_USER_FAIL
} from "../actions/types"

const INITIAL_STATE = {
  errors: {},
  isAuthenticated: false,
  user: {}
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        isAuthenticated: !isEmpty(action.user),
        user: action.user
      }
    case SIGNUP_USER:
      return {...state, loading: true, error: ""}
    case SIGNUP_USER_SUCCESS:
      return {...state}
    case SIGNUP_USER_FAIL:
      return {...state, errors: action.payload, password: "", loading: false}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js